import React from "react";
import { Button, Space, Typography, message } from "antd";
import { ArrowLeftOutlined, UpOutlined, DownOutlined } from "@ant-design/icons";
import { CustomButton } from "../../../components";
import { bulkCreate } from "../../../api's/shipment";
import { showCustomSuccessMessage } from "../../../common/utils";
const { Text } = Typography;

const BulkUploadFooter = ({
  currentErrorCellIndex,
  errorCells,
  token,
  goToError,
  onBackToStep1,
  unauthorize,
  shipmentCount,
  totalShipments,
  totalRecords,
  onCancel,
  data,
  isRowValid,
  prepareCleanedPayload,
  apiResponse,
  showSpin,
  hideSpin,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 8,
          paddingTop: 10,
          width: "100%",
        }}
      >
        <Text style={{ color: "#5E5E5E", fontSize: 14 }}>
          {errorCells.length === 0
            ? "0/0"
            : `${currentErrorCellIndex + 1}/${errorCells.length}`}{" "}
          errors
        </Text>

        <Button
          type="text"
          icon={<UpOutlined style={{ fontSize: 10, color: "black" }} />}
          onClick={() => goToError("up")}
          disabled={errorCells.length === 0}
        />
        <Button
          type="text"
          icon={<DownOutlined style={{ fontSize: 10, color: "black" }} />}
          onClick={() => goToError("down")}
          disabled={errorCells.length === 0}
        />
      </div>

      <div
        className="bulk-upload-editor-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          padding: "16px 0px",
          backgroundColor: "white",
          gap: 12,
        }}
      >
        <Button
          type="default"
          onClick={onBackToStep1}
          icon={<ArrowLeftOutlined />}
          style={{
            fontWeight: 500,
            width: 220,
            height: 36,
            background: "#E8E8E8",
            color: "black",
            fontSize: 14,
          }}
        >
          Change column matching
        </Button>

        <Space style={{ flexWrap: "wrap", gap: 8 }}>
          <img src={shipmentCount} alt="shipment count" />
          <Text
            style={{
              color: totalShipments === 0 ? "#DE1135" : "#5E5E5E",
              fontSize: 12,
              textDecoration: "underline dotted",
              textUnderlineOffset: 2,
            }}
          >
            <span
              style={{
                color: totalShipments === 0 ? "#DE1135" : "black",
                fontWeight: 500,
              }}
            >
              {totalShipments}
            </span>{" "}
            shipments will be created from{" "}
            <span
              style={{
                color: totalShipments === 0 ? "#DE1135" : "black",
                fontWeight: 500,
              }}
            >
              {totalRecords}
            </span>{" "}
            records
          </Text>

          <div
            className="custom-button-group"
            style={{ borderLeft: "1px solid #AFAFAF" }}
          >
            <CustomButton
              key="cancel"
              width={"80px"}
              onClick={onCancel}
              text={"Cancel"}
              bgColor="transparent"
              color="black"
              fontSize="14px"
              fontWeight="600"
              boxShadow="none"
              height="36px"
            />
            <CustomButton
              key="next"
              text="Submit"
              width={"80px"}
              height={36}
              borderRadius={8}
              bgColor="#000"
              color="#fff"
              border="0px"
              fontSize={14}
              fontWeight={500}
              isFormValid={data.every((row) => !isRowValid(row))}
              onClick={() => {
                showSpin();
                const updatedApiResponse = prepareCleanedPayload(
                  apiResponse,
                  data
                );
                bulkCreate(token, updatedApiResponse)
                  .then((res) => {
                    const data = res?.data?.data || null;
                    if (data?.is_success) {
                      showCustomSuccessMessage(data?.message);
                    } else {
                      showCustomSuccessMessage(data?.message);
                    }
                  })
                  .catch((error) => {
                    unauthorize(error);
                    showCustomSuccessMessage("Submission failed. Please try again.");
                  })
                  .finally(() => {
                    onCancel();
                    hideSpin();
                    console.log("Final Cleaned Payload", updatedApiResponse);
                  });
              }}
            />
          </div>
        </Space>
      </div>
    </>
  );
};

export default BulkUploadFooter;
